import axios from 'src/api/axios.config'

export const login = (param, callback) => {
  const url = '/backstage/admin/login'
  axios.post(url, param).then(resp => {
    callback(resp.data)
  }).catch(err => {
    callback(err)
  })
}

export const logout = (callback) => {
  const url = '/backstage/admin/logout'
  axios.post(url, {}).then(resp => {
    callback(resp.data)
  }).catch(err => {
    callback(err)
  })
}

export const testGet = (callback) => {
  const url = `/backstage/admin/test.get`
  axios.get(url).then(resp => {
    console.log('backstage/admin/test.get resp ', resp)
    callback(resp.data)
  }).catch(err => {
    callback(err)
  })
}
